var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContacts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Contacts_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FDFDFD",
  d: "M22 7c-2.127 0-4.418.436-6 1.636C14.418 7.436 12.127 7 10 7s-4.418.436-6 1.636v15.982c0 .71.796.491.818.491 1.473-.709 3.6-1.2 5.182-1.2 2.127 0 4.418.437 6 1.637 1.473-.928 4.145-1.637 6-1.637 1.8 0 3.654.327 5.182 1.146.447.229.818-.208.818-.491V8.636C26.375 7.415 24.04 7 22 7m3.818 15.273c-1.2-.382-2.509-.546-3.818-.546-1.855 0-4.527.71-6 1.637V10.818c1.473-.927 4.145-1.636 6-1.636 1.31 0 2.618.163 3.818.545z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Contacts_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export default SvgContacts;